import { useQuery } from '@tanstack/react-query';
import { getMapData } from 'services/reactQueryservices';
import { mapDataKey } from 'react_query/query-keys';

const useMapdata = (locationType: string, type: string, projectId: number, enabled: boolean = true) => {
    const { data, isFetching, error } = useQuery({
        queryKey: [mapDataKey, locationType, type, projectId],
        queryFn: () => getMapData(locationType, type, projectId),
        enabled: enabled
    });

    return {
        data,
        isFetching,
        error
    };
};

export default useMapdata;
